<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

    <v-app dark id="inspire">

        <v-content>
            <v-container
                    class="fill-height"
                    fluid
            >
                <v-row
                        align="center"
                        justify="center"
                >
                    <v-col
                            class="animated bounceIn"
                            cols="12"
                            :sm="8"
                            :md="4"
                            align="center"
                    >
                        <div class="loginForm pa-12 pt-10 pb-5 mb-5">
                            <v-img height="3rem" contain
                                   src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/biaoti.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753405906&Signature=YUHQovwsFHMVKbBEMfb1dywREXE%3D"></v-img>
                            <v-card-text>
                                <v-form
                                        ref="form"
                                >
                                    <v-text-field
                                            color="#fff"
                                            solo
                                            id="acctNo"
                                            v-model="loginRequest.acctNo"
                                            :rules="[v => !!v || '必输的哦~']"
                                            name="login"
                                            prepend-icon="person"
                                            type="text"
                                    />
                                    <v-text-field
                                            color="#fff"
                                            id="password"
                                            solo
                                            v-model="loginRequest.passWord"
                                            :rules="[v => !!v || '必输的哦~']"
                                            name="password"
                                            prepend-icon="lock"
                                            type="password"

                                    />
                                    <v-text-field
                                            color="#fff"
                                            label="验证码"
                                            name="verify"
                                            solo
                                            v-model="loginRequest.verifyCode"
                                            :rules="[v => !!v || '必输的哦~']"
                                            prepend-icon="code"
                                            type="text"
                                    >
                                        <template v-slot:append-outer>
                                            <v-img @click="refreshVerfyImg" :src="verifyData.verifyImg"></v-img>
                                        </template>
                                    </v-text-field>
                                </v-form>
                            </v-card-text>
                        </div>
                        <v-img width="60%" @click="commit" contain
                               style="cursor:pointer"
                               src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/denglu_btn.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753405925&Signature=mOYMSUSMi2Y7x%2BKBrqpTpC0MsM4%3D"></v-img>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>


        <z-notify ref="notify"></z-notify>

    </v-app>
</template>

<script>
  import {imgVerify, hospUserLogin} from '@/api/login'
  import scrypt from '@/utils/scrypt'

  export default {
    name: "AdminLogin",
    data() {
      return {
        verifyData: {
          verifyImg: '',
          verifyId: '',
          verifyCode: ''
        },
        loginRequest: {
          verifyId: '',
          verifyCode: '',
          acctNo: '',
          passWord: ''
        },

      }
    },
    methods: {
      commit() {
        console.log("提交");
        if (this.$refs.form.validate()) {
          this.loginRequest.passWord = scrypt.Encrypt(this.loginRequest.passWord)  //
          hospUserLogin(this.loginRequest).then(res => {
            if (res.verifyResult == '1') {
              this.$store.dispatch('logIn', res.token)
              // this.$refs.form.reset();
              this.$router.push({path: '/data-platform'})
            } else if (res.verifyResult == '-1') {
              this.$refs.notify.show("验证码", {timeout: 1000})
              this.loginRequest.passWord = ''
              this.refreshVerfyImg()
            } else if (res.verifyResult == '0') {
              this.loginRequest.passWord = ''
              this.$refs.notify.show("验证码输入错误", {timeout: 1000})
              this.refreshVerfyImg()
            }
          }).catch(err => {
            console.error(err)
            this.loginRequest.passWord = ''
          })
        }
      },
      refreshVerfyImg() {
        this.loginRequest.verifyCode = ''
        let req = {
          width: 100,
          height: 30
        }
        imgVerify(req).then(res => {
          this.verifyData.verifyImg = 'data:image/gif;base64,' + res.imgData
          this.loginRequest.verifyId = res.verifyId
          // this.loginRequest.verifyCode = res.verifyCode
        }).catch(err => console.error(err))
      }
    },
    created() {
      this.refreshVerfyImg()
      this.$vuetify.theme.dark = false

    }
  }
</script>

<style scoped>

    @import '../style/animate.min.css';

    #inspire {
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/homeBg.gif?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753405951&Signature=%2FT%2Fizx%2FfHDIye8TlHJMr9jr6snQ%3D");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
    }

    .loginForm {
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/denglukuang.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753405980&Signature=6XmFF8BS6hpJVQeWCsAeLUyivQU%3D");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
    }

</style>
